import { apiClient, type ShipmentOrderInputHistoryListEntity } from '@/libs/api'
export type UpdatedShipmentOrderHistoryEntity =
  ShipmentOrderInputHistoryListEntity

export type UpdateShipmentOrderHistoryRequest = {
  tenantKey: string
  id: number
  dto: {
    name: string
  }
}

// 配送依頼履歴の更新API
export const updateShipmentOrderHistory = async ({
  tenantKey,
  id,
  dto
}: UpdateShipmentOrderHistoryRequest): Promise<ShipmentOrderInputHistoryListEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.histories._id(id)
    .$put({
      body: dto
    })

  return data
}
